"use strict";
/*
 * HSTextareaAutoHeight
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSTextareaAutoHeight = /** @class */ (function (_super) {
    __extends(HSTextareaAutoHeight, _super);
    function HSTextareaAutoHeight(el, options) {
        var _this = _super.call(this, el, options) || this;
        var data = el.getAttribute('data-hs-copy-markup');
        var dataOptions = data
            ? JSON.parse(data)
            : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.defaultHeight = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.defaultHeight) || 0;
        _this.init();
        return _this;
    }
    HSTextareaAutoHeight.prototype.init = function () {
        this.createCollection(window.$hsTextareaAutoHeightCollection, this);
        this.setAutoHeight();
    };
    HSTextareaAutoHeight.prototype.setAutoHeight = function () {
        var _this = this;
        if (this.isParentHidden())
            this.callbackAccordingToType();
        else
            this.textareaSetHeight(3);
        this.el.addEventListener('input', function () { return _this.textareaSetHeight(3); });
    };
    HSTextareaAutoHeight.prototype.textareaSetHeight = function (offsetTop) {
        if (offsetTop === void 0) { offsetTop = 0; }
        this.el.style.height = 'auto';
        this.el.style.height =
            this.checkIfOneLine() && this.defaultHeight
                ? "".concat(this.defaultHeight, "px")
                : "".concat(this.el.scrollHeight + offsetTop, "px");
    };
    HSTextareaAutoHeight.prototype.checkIfOneLine = function () {
        var clientHeight = this.el.clientHeight;
        var scrollHeight = this.el.scrollHeight;
        if (scrollHeight > clientHeight)
            return false;
        else
            return true;
    };
    HSTextareaAutoHeight.prototype.isParentHidden = function () {
        return this.el.closest('.hs-collapse') || this.el.closest('.hs-overlay');
    };
    HSTextareaAutoHeight.prototype.parentType = function () {
        if (this.el.closest('.hs-collapse'))
            return 'collapse';
        else if (this.el.closest('.hs-overlay'))
            return 'overlay';
        else
            return false;
    };
    HSTextareaAutoHeight.prototype.callbackAccordingToType = function () {
        var _this = this;
        if (this.parentType() === 'collapse') {
            var collapseId = this.el.closest('.hs-collapse').id;
            var element = window.HSCollapse.getInstance("[data-hs-collapse=\"#".concat(collapseId, "\"]"), true).element;
            element.on('beforeOpen', function () {
                if (!_this.el)
                    return false;
                _this.textareaSetHeight(3);
            });
        }
        else if (this.parentType() === 'overlay') {
            var element = window.HSOverlay.getInstance(this.el.closest('.hs-overlay'), true).element;
            element.on('open', function () {
                if (!_this.el)
                    return false;
                _this.textareaSetHeight(3);
            });
        }
        else
            return false;
    };
    // Static method
    HSTextareaAutoHeight.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsTextareaAutoHeightCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element
            : null;
    };
    HSTextareaAutoHeight.autoInit = function () {
        if (!window.$hsTextareaAutoHeightCollection)
            window.$hsTextareaAutoHeightCollection = [];
        document
            .querySelectorAll('[data-hs-textarea-auto-height]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsTextareaAutoHeightCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; })) {
                var data = el.getAttribute('data-hs-textarea-auto-height');
                var options = data
                    ? JSON.parse(data)
                    : {};
                new HSTextareaAutoHeight(el, options);
            }
        });
    };
    return HSTextareaAutoHeight;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSTextareaAutoHeight.autoInit();
    // Uncomment for debug
    // console.log('Textarea Autoheight collection:', window.$hsTextareaAutoHeightCollection);
});
if (typeof window !== 'undefined') {
    window.HSTextareaAutoHeight = HSTextareaAutoHeight;
}
exports.default = HSTextareaAutoHeight;
